export class LoginMode {
    type: LoginModeType;
    params: string;
    enabled: boolean;

    constructor() {}

    parse(obj: any) {
        if (obj.Type != null && Object.values(LoginModeType).includes(obj.Type)) this.type = obj.Type;
        this.enabled = obj.Enabled;
        if (obj.Params != null) this.params = obj.Params;
    }
}

export enum LoginModeType {
    ADLegacy,
    AzureAD,
}

export class ADLegacyParams {
    Host: string;
    Username: string;
    Password: string;
    Groups_container: string;
    Get_group_filter: string;
    Users_container: string;
    Get_user_filter: string;
}

export class AzureADParams {
    clinkRedirectPage: string;
    msalConfig_auth_clientId: string;
    msalConfig_auth_authority: string;
}

export function loginModeTypeEnumLabel(value: LoginModeType): string {
    switch (value) {
        case LoginModeType.ADLegacy:
            return "enum.loginModeType.ADLegacy";
        case LoginModeType.AzureAD:
            return "enum.loginModeType.AzureAD";
        default:
            return "common.unknown";
    }
}
